// removed by extract-text-webpack-plugin
module.exports = {"Error":"_34cTo8Qd8VzX-fbtJ4hB","Warning":"_15YiIYQYWybeyH9zW5lGGk","Success":"_2Yayc3RA4cXiCmq1iC7o20","Info":"_28RpUF18mDiDw433vJa73t","Icon":"_36qExuK3F7ZESZ57GpRMO4"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Message/styles.module.css
// module id = 591
// module chunks = 0